import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import {
  fetchAdminResourcePage,
  type AdminResourceListResult,
} from '../../services/adminResourceList';

export const adminResourceListQueryKey = (
  resourceName: string,
  page: number,
  pageSize: number,
  query: string
) =>
  ['admin', 'resource', resourceName, 'list', page, pageSize, query] as const;

export function useAdminResourceListQuery(
  resourceName: string,
  page: number,
  pageSize: number,
  query: string,
  options?: UseQueryOptions<AdminResourceListResult, Error>
) {
  return useQuery<AdminResourceListResult, Error>({
    queryKey: adminResourceListQueryKey(resourceName, page, pageSize, query),
    queryFn: () =>
      fetchAdminResourcePage(
        resourceName,
        page,
        pageSize,
        query.trim().length > 0 ? query : undefined
      ),
    staleTime: 30 * 1000,
    refetchOnWindowFocus: false,
    ...options,
  });
}
